<template>
  <div class="carousel carousel-slider">
    <a v-if="capa" class="carousel-item modal-trigger"  href="#modal1"  @click="AbrirModal(urlApi + 'produtos/' + capa)">
      <img  class=" responsive-img" v-lazy="urlApi + 'produtos/' + capa">
      </a>
    <a class="carousel-item modal-trigger"  href="#modal1" v-for="item in imagens" :key="item.id" @click="AbrirModal(urlApi + 'galerias/' + item.arquivo)">
      <img  class=" responsive-img" v-lazy="urlApi + 'galerias/' + item.arquivo">
    </a>
  </div>
</template>

<script>
export default {
  name: "CarrouselComponent",
  props:["capa"],
  data(){
    return{
      carousel:null,
      item:{id:0, arquivo:""},
      imagens:this.$store.state.produto.galerias,
      urlApi:this.$store.state.url_files,
    };
  },
  methods:{
    AbrirModal(url){
      this.$store.commit('imagem_zoom',url)
    }
  },
  mounted() {
    $(document).ready(function() {
      setTimeout(()=>{
         $(".carousel.carousel-slider").carousel({
          fullWidth: true,
          indicators: true
        });
         $('.materialboxed').materialbox();
         $('.modal').modal();
      },500)

    });
  }
};
</script>


<style scoped>
@media only screen and (max-width : 450px) {
  .carousel {
    max-height: 250px;
  }
}

@media only screen and (min-width : 450px) {
  .carousel {
    max-height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/CarrouselComponent.vue